export const RcsMessageCategories = {
  CARD: 'CARD',
  CAROUSEL: 'CAROUSEL',
  TEXT: 'TEXT',
} as const;

export const RcsMessageCategoryLabels = {
  [RcsMessageCategories.CARD]: 'RCS Card',
  [RcsMessageCategories.CAROUSEL]: 'RCS Card Carousel',
  [RcsMessageCategories.TEXT]: 'Text RCS',
} as const;

export const RcsMessageButtonTypes = {
  CLICK_TO_REPLY: 'click_to_reply',
  OPEN_URL: 'open_url',
} as const;
